import React, { useState } from "react";
import loadable from "@loadable/component";
import { useIsMobile } from "../../hooks";

import { filterHepaStatic, filterImoji } from "../../static-data";
import { FILTER_NAMES } from "../../../shared/enums";

const LazyImg = loadable(() => import("../common/LazyImg"));
const FadeIn = loadable(() => import("../common/FadeIn"));

const FilterHepaStats = () => {
  const [filterType, setFilterType] = useState("air");
  const isMobile = useIsMobile(1024);
  const hepaData = filterHepaStatic[filterType];
  return (
    <section className="p-hepa-stats">
      <div className="container">
        <div className="p-hepa-stats__header">
          <FilterHepaStatsTab
            filterType={filterType}
            setFilterType={setFilterType}
            isMobile={isMobile}
          />
        </div>
        <div className="p-hepa-stats__body">
          {isMobile ? (
            <FilterHepaResponsive
              filterHepaStatic={filterHepaStatic}
              hepaData={hepaData}
            />
          ) : (
            <FilterHepaDesktop
              filterHepaStatic={filterHepaStatic}
              hepaData={hepaData}
            />
          )}
        </div>
      </div>
    </section>
  );
};

function FilterHepaStatsTab({ filterType, setFilterType, isMobile }) {
  return (
    <div className="p-hepa-stats__tab">
      <ul className="p-hepa-stats__tab-list">
        <li>
          <button
            type="button"
            className={`p-hepa-stats__tab-button ${
              filterType === "air" ? "active" : ""
            }`}
            onClick={() => setFilterType("air")}
          >
            {isMobile ? "Mila Air 3" : "Air 3"}
          </button>
        </li>
        <li>
          <button
            type="button"
            className={`p-hepa-stats__tab-button ${
              filterType === "airMini" ? "active" : ""
            }`}
            onClick={() => setFilterType("airMini")}
          >
            {isMobile ? "Mila Air Mini" : "Air Mini"}
          </button>
        </li>
      </ul>
    </div>
  );
}
function FilterHepaDesktop({ filterHepaStatic, hepaData }) {
  return (
    <div className="p-hepa-table">
      <div className="p-hepa-table__header">
        <div className="p-hepa-table__grid">
          <div className="p-hepa-table__column"></div>
          {filterHepaStatic.category.map((item, index) => {
            const key = Object.keys(item)[0];
            const value = item[key];
            return (
              <div className="p-hepa-table__column" key={index}>
                <strong
                  className="p-hepa-table__column-title"
                  dangerouslySetInnerHTML={{ __html: value }}
                />
              </div>
            );
          })}
        </div>
      </div>

      <div className="p-hepa-table__body">
        {Object.entries(hepaData).map(([filterKey, filterData]) => (
          <div className="p-hepa-table__grid" key={filterKey}>
            <div className="p-hepa-table__column">
              <div className="p-hepa-table__label">
                <FadeIn>
                  <LazyImg
                    src={filterImoji[filterKey]}
                    alt={FILTER_NAMES[filterKey]}
                    className="p-hepa-table__label-img"
                  />
                </FadeIn>
                <strong>The {FILTER_NAMES[filterKey]}</strong>
                {/* <span className="tooltip">
                  <svg className="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                  <span className="tooltiptext">{filterData.tooltip}</span>
                </span> */}
              </div>
            </div>
            {filterHepaStatic.category.map((item, index) => {
              const dataKey = Object.keys(item)[0];
              return (
                <div className="p-hepa-table__column" key={index}>
                  <span className="p-hepa-table__value">
                    {filterData[dataKey]}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

function FilterHepaResponsive({ filterHepaStatic ,hepaData}) {
  const [activeItem, setActiveItem] = useState("class");
  return (
    <div className="p-hepa-table-res">
      <div className="p-hepa-table-res__header">
        <div className="p-hepa-table-res__tab">
          <ul className="p-hepa-table-res__tab-list">
            {filterHepaStatic.category.map((item, index) => {
              const key = Object.keys(item)[0];
              const value = item[key];
              return (
                <li
                  key={index}
                  className={`${activeItem === key ? "active" : ""}`}
                >
                  <button
                    type="button"
                    onClick={() => setActiveItem(key)}
                    dangerouslySetInnerHTML={{ __html: value }}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="p-hepa-table-res__body">
        {Object.entries(hepaData).map(([filterKey, filterData]) => (
          <div className="p-hepa-table-res__item">
            <strong className="p-hepa-table-res__label">
              <FadeIn>
                <LazyImg
                  src={filterImoji[filterKey]}
                  alt={FILTER_NAMES[filterKey]}
                  className="p-hepa-table__label-img"
                />
              </FadeIn>
              The {FILTER_NAMES[filterKey]}
            </strong>
            <div className="p-hepa-table-res__value">
              <span>{filterData[activeItem]}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default FilterHepaStats;
